import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";

import type { Service } from "@mirage/service-fss-bridge/service";
import type { UnavailableSource } from "./service/bridge_types";

const service = services.getp<Service>(ServiceId.FSS_BRIDGE);
const service$ = services.get<Service>(ServiceId.FSS_BRIDGE);

export function readyPage() {
  return service.readyPage();
}

export function isSupportedEnv() {
  return service.isSupportedEnv();
}

export function openAddSourceModal() {
  return service.openAddSourceModal();
}

export function updateConversation(conversationID: string) {
  return service.updateConversation(conversationID);
}

export function closeSidebar() {
  return service.closeSidebar();
}

export function notifyLogin(uid: number) {
  return service.notifyLogin(uid);
}

export function notifyLogout() {
  return service.notifyLogout();
}

export function openSessionHistory() {
  return service.openSessionHistory();
}

export function openUnavailableSources(
  unavailableSources: UnavailableSource[],
) {
  return service.openUnavailableSources(unavailableSources);
}

export const observeConversationEvents = service$.observeConversationEvents;
export const observeActionEvents = service$.observeActionEvents;
